import { IUser, ISummaryCard } from '@base/interfaces';
import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';

@Component({
  selector: 'app-widget-admin',
  templateUrl: './widget-admin.component.html',
  styleUrls: ['./widget-admin.component.sass']
})
export class WidgetAdminComponent implements OnInit, OnChanges {
  @Input() data: object;
  @Input() info: ISummaryCard;
  @Input() type: string;
  activeUsers: IUser[];
  inactiveUsers: IUser[];

  constructor() {
    this.data = {enabled: 0, disabled: 0};
    this.activeUsers = [];
    this.inactiveUsers = [];
    this.info = Object.assign({});
    this.type = '';
  }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    this.info.subtitle = `${(this.data['enabled'] + this.data['disabled'])} ${this.type} registrados`;
  }
}
